import { StateCreator } from 'zustand';
import { TerraProvider } from '../../../types/TerraProvider';

export interface WearableSdkSlice {
  wearableSdkInitialized: boolean;
  setWearableSdkInitialized: (initialized: boolean) => void;
  lastSyncDate: Date | undefined;
  setLastSyncDate: (lastSyncDate: Date) => void;
  wearableProviders: TerraProvider[];
  setWearableProviders: (providers: TerraProvider[]) => void;
}

export const createWearableSdkSlice: StateCreator<WearableSdkSlice, [], [], WearableSdkSlice> = (set) => ({
  wearableSdkInitialized: false,
  setWearableSdkInitialized: (initialized: boolean) => set(() => ({ wearableSdkInitialized: initialized })),
  lastSyncDate: undefined,
  setLastSyncDate: (lastSyncDate: Date) => set(() => ({ lastSyncDate })),
  wearableProviders: [],
  setWearableProviders: (providers: TerraProvider[]) => {
    set({ wearableProviders: providers });
  }
});
